/*
 * 网站首页接口
 * */
import services from "../config/axios";
import base from './base';
// 定义参数类型
type paramsType<T> = {
  [key: string]: T;
};


const dashboardAPI = {
  // 获取概要
  getStatisticInfo<T>(params: FormData) {
    return services.post(`${base.lk}/Dashboard/GetStatisticInfo`, params);
  },
  //获取排名
  getRankingData<T>(params: FormData) {
    return services.post(`${base.lk}/Dashboard/GetRankingData`, params)
  },
  //获取用例
  getCaseData<T>(params: FormData) {
    return services.post(`${base.lk}/Dashboard/GetCaseData`, params)
  },
  getTableauUrl<T>(){
    return services.post(`${base.lk}/Dashboard/GetTableauUrl`)
  },
  getCoEContact<T>(){
    return services.post(`${base.lk}/Dashboard/GetCoEContact`)
  },
  getDivisionYearDE<T>(params: FormData) {
    return services.post(`${base.lk}/NewDashboard/GetDivisionYearDE`, params)
  },
  getStatistics<T>(params: FormData) {
    return services.post(`${base.lk}/NewDashboard/GetStatistics`, params)
  },
  getDivisionSummary<T>(params: FormData) {
    return services.post(`${base.lk}/NewDashboard/GetDivisionSummary`, params)
  },
  // GetMyDigitalEmpList
  getMyDigitalEmpList<T>(params: FormData) {
    return services.post(`${base.lk}/NewDashboard/GetMyDigitalEmpList`, params)
  },
  // GetMyReqsList 
  getMyReqsList<T>(params: FormData) {
    return services.post(`${base.lk}/NewDashboard/GetMyReqsList`, params)
  },
  // GetMyPubsList 
  getMyPubsList<T>(params: FormData) {
    return services.post(`${base.lk}/NewDashboard/GetMyPubsList`, params)
  },
  // GetAdList
  getAdList<T>(params: FormData) {
    return services.post(`${base.lk}/NewDashboard/GetAdList`, params)
  },
  // GetMyPlazaList
  getMyPlazaList<T>(params: FormData) {
    return services.post(`${base.lk}/NewDashboard/GetMyPlazaList`, params)
  },
  // GetTalentPlazaList
  getTalentPlazaList<T>(params: FormData) {
    return services.post(`${base.lk}/NewDashboard/GetTalentPlazaList`, params)
  },
  // AddDigitalEmpLogs
  addDigitalEmpLogs<T>(params: FormData) {
    return services.post(`${base.lk}/NewDashboard/AddDigitalEmpLogs`, params)
  },

};

export default dashboardAPI;
